import { h, Component } from 'preact';
import { connect } from 'preact-redux';
import classNames from 'classnames';
import * as navbarActions from 'app/desktop/actions/navbar';
import { categoriesSelector } from 'app/desktop/selectors/categories';

class Categories extends Component {
  constructor(props) {
    super(props);

    this.handleDocumentActive = this.handleDocumentActive.bind(this);
  }
  componentDidMount() {
    document.addEventListener('click', this.handleDocumentActive);
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentActive);
  }

  handleDocumentActive(e) {
    const isCategoriesFlyoutHidden = document.getElementsByClassName(
      'ls-hide cat-flyout-wrapper'
    ).length;

    if (isCategoriesFlyoutHidden) {
      return;
    } else if (
      !e.target.closest('#btn-categories') &&
      e.target.closest(
        '.ls-signin-flyout, .ls-signin-form, .ls-search-wrapper, .signin-container'
      )
    ) {
      this.props.showCategoriesFlyout();
    }
  }
  render() {
    const { t, isCategoriesFlyoutDisplayed } = this.props;
    return (
      <div
        id="btn-categories"
        className={classNames('redesign-buttons icon icon-arrow-down-large', {
          'flyout-visible': isCategoriesFlyoutDisplayed,
        })}
        role="button"
        tabIndex="0"
        onClick={this.props.showCategoriesFlyout}
      >
        {t.header.categories}
      </div>
    );
  }
}

export default connect(
  categoriesSelector,
  navbarActions
)(Categories);
